import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import * as actions from 'actions';
import { getChatState } from 'selectors';
import './style.scss';

export class ChatBubble extends Component {

  constructor() {
    super();
    this.handleClicked = this.handleClicked.bind(this);
  }

  handleClicked() {
    this.props.onSelected();
  }

  render() {
    return (
      <div className="ChatBubble" onClick={this.handleClicked}>
        <span className="icon-chat-circle"></span>

        {(() => {
          if(this.props.showsUnreadMessagesCount) {
            return <div className="notification">{this.props.unreadMessagesCount}</div>;
          }
        })()}
      </div>
    );
  }
}

ChatBubble.propTypes = {
  unreadMessagesCount: PropTypes.number,
  showsUnreadMessagesCount: PropTypes.bool,
  onSelected: PropTypes.func
};

const mapStateToProps = state => {
  const unreadMessagesCount = getChatState(state).unreadMessagesCount;

  return {
    unreadMessagesCount,
    showsUnreadMessagesCount: unreadMessagesCount > 0
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSelected: () => {
      dispatch(actions.chatOpen());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatBubble);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatBubble/index.js
 **/